// extracted by mini-css-extract-plugin
export var actionButtons = "FullScreenError-module--actionButtons--07684";
export var centered = "FullScreenError-module--centered--edf5f";
export var errorPage = "FullScreenError-module--errorPage--e1516";
export var img = "FullScreenError-module--img--2ab55";
export var logo = "FullScreenError-module--logo--56ce4";